import type { CSSProperties } from 'react';
import React from 'react';

import { extractSizeFromClassName } from '../common';
import Avatar, { AvatarProps } from './Avatar';
import NextJsAvatar from './NextJsAvatar';

type TeamAvatarProps = Omit<AvatarProps, 'srcs' | 'alt'> & {
  userTeam?: {
    userTeamName?: string | null;
    profilePicture?: string | null;
    userEmail?: string | null;
    name?: string | null;
  };
  connected?: boolean;
  nextjs?: boolean;
};

export default function TeamUserAvatar({ userTeam, connected, ref, nextjs, ...props }: TeamAvatarProps) {
  const size = extractSizeFromClassName(props.className) ?? 12;

  const outlineSize = Math.floor(size / 6);
  const shadowSize = Math.floor(size / 4);
  const style: CSSProperties = {};

  if (connected == true) {
    style.outline = `${outlineSize}px solid hsl(120deg 84.08% 33.97%)`;
    style.boxShadow = `0 0 0px ${shadowSize}px var(--drop-shadow-color)`;
  } else if (connected == false) {
    style.boxShadow = `0 0 0px ${shadowSize - outlineSize}px var(--drop-shadow-color)`;
  }

  if (nextjs) {
    return (
      <NextJsAvatar
        ref={ref}
        alt={userTeam?.userTeamName || userTeam?.userEmail || userTeam?.name || '?'}
        srcs={[userTeam?.profilePicture]}
        coloredBackground
        style={style}
        {...props}
      />
    );
  } else {
    return (
      <Avatar
        ref={ref}
        alt={userTeam?.userTeamName || userTeam?.userEmail || userTeam?.name || '?'}
        srcs={[userTeam?.profilePicture]}
        coloredBackground
        style={style}
        {...props}
      />
    );
  }
}